import { render, staticRenderFns } from "./_requests.tab.vue?vue&type=template&id=168b14ba&scoped=true&"
import script from "./_requests.tab.vue?vue&type=script&lang=js&"
export * from "./_requests.tab.vue?vue&type=script&lang=js&"
import style0 from "./_requests.tab.vue?vue&type=style&index=0&id=168b14ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b14ba",
  null
  
)

export default component.exports